import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icons,
} from "@/components/ui";
import { useT } from "@/i18n";
import { toastsMessages } from "@/i18n/messages/toasts";

export interface ToastMenuItem {
  id: string;
  label: string;
  onSelect: () => void;
}

/** Second-degree toast actions behind a vertical ⋮ (spec D3, D7). */
export function ToastMoreMenu({
  items,
  testId,
  onOpenChange,
  tray = false,
}: {
  items: ToastMenuItem[];
  testId: string;
  onOpenChange?: (open: boolean) => void;
  tray?: boolean;
}) {
  const t = useT(toastsMessages);
  return (
    <DropdownMenu modal={false} onOpenChange={onOpenChange}>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="iconSm"
          aria-label={t("more")}
          data-testid={testId}
          data-interactive="true"
          onClick={(event) => event.stopPropagation()}
        >
          <Icons.MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="min-w-[176px]"
        // Toast pills stack in an overlay at TOAST_Z_INDEX (31499), above the
        // base menu tier (31000) — without this promotion a ⋮ menu opening
        // downward paints behind the next opaque pill and can't be seen or
        // clicked. The z-source rule lives in index.css next to
        // data-modal-menu; Radix copies the content's computed z-index onto
        // its popper wrapper.
        data-toast-menu="true"
        data-tray-menu={tray || undefined}
      >
        {items.map((item) => (
          <DropdownMenuItem
            key={item.id}
            onSelect={item.onSelect}
            data-testid={`toast-menu-item-${item.id}`}
          >
            {item.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
